import { FadeIn } from "./ui";
import { AlertCircle, TrendingDown, RefreshCcw, LayoutTemplate, Target, BarChart3 } from "lucide-react";

const painPoints = [
  {
    icon: Target,
    text: "Meu produto é bom, mas o concorrente — com produto pior — vende mais do que eu"
  },
  {
    icon: AlertCircle,
    text: "Já contratei agência e senti que joguei dinheiro fora. Não entendia o que estava sendo feito"
  },
  {
    icon: BarChart3,
    text: "Faço posts, invisto dinheiro em tráfego, mas não vejo resultado concreto em faturamento"
  },
  {
    icon: RefreshCcw,
    text: "Marketing e vendas na minha empresa não se conversam — cada um faz sua parte no escuro"
  },
  {
    icon: LayoutTemplate,
    text: "Minha marca não tem identidade clara — comunicamos diferente em cada canal e situação"
  },
  {
    icon: TrendingDown,
    text: "Estou estagnado no mesmo faturamento há meses — e não sei exatamente o que está travando"
  }
];

export function PainPoints() {
  return (
    <section className="relative pb-24 pt-12 bg-brand-dark text-brand-light overflow-x-clip">
      {/* Marquee Divider */}
      <div className="relative w-full flex bg-brand-accent text-brand-light py-3 md:py-4 -rotate-2 scale-110 z-20 shadow-2xl mb-24 border-y border-brand-dark">
        <div className="flex whitespace-nowrap animate-marquee">
          {[...Array(10)].map((_, i) => (
            <div key={i} className="flex items-center">
              <span className="text-2xl md:text-4xl font-black uppercase tracking-tighter mx-6">Soluções Integradas</span>
              <span className="text-2xl md:text-4xl font-highlight italic mx-6 text-brand-dark">*</span>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <FadeIn className="mb-16 md:mb-20">
          <div className="flex items-center gap-4 mb-6">
            <div className="h-[2px] w-8 bg-brand-accent"></div>
            <span className="text-brand-accent font-bold uppercase tracking-widest text-sm">Você se reconhece aqui?</span>
          </div>
          <div className="grid md:grid-cols-2 gap-8 items-end">
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-black uppercase tracking-tighter leading-[0.9]">
              Situações que <br className="hidden lg:block" />
              empresários como você <span className="font-highlight italic text-brand-accent lowercase font-normal">vivem</span>
            </h2>
            <p className="text-xl md:text-2xl text-brand-light/70 font-medium leading-relaxed md:pb-2">
              Marque mentalmente quantas se aplicam. Se for mais de uma, a P2A foi feita para você.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2}>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-[1px] bg-brand-light/10 border border-brand-light/10 rounded-[2rem] overflow-hidden shadow-2xl">
            {painPoints.map((point, index) => (
              <div
                key={index}
                className="group p-8 md:p-12 bg-brand-dark hover:bg-brand-accent transition duration-500 flex flex-col justify-between min-h-[280px] relative overflow-hidden cursor-default"
              >
                <div className="absolute inset-0 bg-paper opacity-40 pointer-events-none mix-blend-multiply"></div>

                <div className="flex justify-between items-start relative z-10 mb-8">
                  <div className="w-14 h-14 rounded-full bg-brand-light/5 group-hover:bg-brand-dark/10 flex items-center justify-center text-brand-accent group-hover:text-brand-dark transition-colors duration-500">
                    <point.icon className="w-7 h-7" />
                  </div>
                  <div className="text-5xl font-highlight font-bold text-brand-light/10 group-hover:text-brand-dark/20 transition-colors duration-500">
                    0{index + 1}
                  </div>
                </div>

                <p className="text-lg md:text-xl text-brand-light/80 group-hover:text-brand-dark font-medium leading-relaxed relative z-10 transition-colors duration-500">
                  {point.text}
                </p>
              </div>
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
